<template>
    <modal-simple :closeBtn="false" :id="id">
        <template v-slot:header>
            <div class="background-standard shadow-standard mt-4" style="height: 60px; width: 100%">
                <br>
                <span style="color:white; font-size: 20px; font-weight: 600;">{{titles.confirmation}}</span>
            </div>
        </template>
        <template v-slot:content>
            <br>
            <h4 class="mb-4">{{title}}</h4>

            <div class="col-md-10" style="display: block; margin-left: auto; margin-right: auto;">
                <Input :disabled="false"
                       :icon="icons.password"
                       :inputKey="'password'"
                       :name="titles.oldpassword"
                       :type="'password'"
                       :validate="$v.password"
                       @method="getValue"
                />
                <div :class="{ 'invalid-feedback-erreur':  verifpassword}"
                     class="invalid-feedback">
                    {{titles.passwordInvalid}}
                </div>
            </div>
            <button @click="closeModal(id)" class="btn btn-cancel-gradient float-left w-25" type="button">
                {{titles.toCancel}}
            </button>
            <button @click="confirmModal(id)" class="btn btn-standard-gradient float-right w-25" type="button">
                {{titles.toConfirm}}
            </button>
        </template>
    </modal-simple>
</template>

<script>
    import ModalSimple from './modal-simple';
    import {titles} from '../../utils/general/titles';
    import {icons} from '../../utils/general/icons';
    import Input from './Input';
    import {
        helpers,
        minLength,
        required
    } from 'vuelidate/lib/validators';
    import {getVerifPassword} from '../shared/services/user.service';

    const mustBeValidPassword = helpers.regex(
        'alpha',
        /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    );
    export default {
        name: 'modal-password',
        components: {ModalSimple, Input},
        props: {
            id: String,
            title: String
        },
        data() {
            return {
                titles,
                icons,
                isClosed: false,
                password: null,
                verifpassword: false
            };
        },
        validations: {
            password: {required, mustBeValidPassword, minLength: minLength(6)}
        },
        created() {
            this.isClosed = false;
        },
        methods: {
            getValue(inputKey, val) {
                this.verifpassword = false;
                this.$v.$touch();
                this[inputKey] = val;
            },
            closeModal(id) {
                this.$bvModal.hide(id);
                this.isClosed = true;
                this.$emit('messageFromModalPassword', this.isClosed);
            },
            confirmModal(id) {
                const user = this.$cookies.get('user');
                getVerifPassword(user.email, this.password).then(
                    response => {
                        if (response.data == 'Error') {
                            this.verifpassword = true;
                        } else {
                            this.$bvModal.hide(id);
                            this.$emit('messageFromModalPassword', this.password);
                        }
                    });

            }
        }
    };
</script>

<style lang="scss" scoped>
    img {
        position: relative;
        top: -15px;
        width: 6rem;
    }

    .voucher-text {
        color: #5a5c61;
    }
</style>
